import React from "react";
import PropTypes from "prop-types";

/**
 * Default Cell component
 * @module
 * @param {node} children - Children element
 * @param {object} tdProps - td props
 */
export const DefaultCell = (props) => {
  const { children, tdProps } = props;
  return (
    <td {...tdProps}>
      {children}
    </td>
  );
};

DefaultCell.propTypes = {
  children: PropTypes.node,
  tdProps: PropTypes.object,
};